import { Controller } from "stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element, {
      backdrop: true,
      keyboard: true
    })
    this.modal.show()

    this.element.addEventListener('hidden.bs.modal', () => {
      // Clean up backdrop and body classes
      const backdrop = document.querySelector('.modal-backdrop')
      if (backdrop) {
        backdrop.remove()
      }
      document.body.classList.remove('modal-open')
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
      
      this.element.remove() // Clean up modal DOM after closing
    })
  }

  disconnect() {
    if (this.modal) {
      this.modal.dispose()
    }
    
    // Extra cleanup in case disconnect is called before hidden.bs.modal
    const backdrop = document.querySelector('.modal-backdrop')
    if (backdrop) {
      backdrop.remove()
    }
    document.body.classList.remove('modal-open')
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
  }
}